var FontFamily = "OpenSans, \"Helvetica Neue\", Helvetica, Arial, sans-serif";
var FontSizeTitleHeadline = "30px";
var FontSizeTitleSection = "22px";
var FontSizeTitleSubsection = "16px";
var FontSizeDefault = "13px";
var FontSizeLabel = "11px";
var FontWeightSemibold = "600";
var FontWeightNormal = "400";
var FontWeightLight = "300";
var BorderRadiusDefault = "3px";
var BorderRadiusL = "4px";
var FontColorDefault = "#000000";
var FontColorGray = "rgba(0, 0, 0, 0.7)";
var FontColorLightGray = "rgba(0, 0, 0, 0.45)";
var FontColorWhite = "#FFFFFF";
var FontColorError = "#AE304A";
var FontColorAttention = "#AE304A";
var FontColorWarning = "#E6961E";
var FontColorSuccess = "#5FA253";
var FontColorSelected = "#007EFF";
var LinkColor = "#007EFF";
var LinkColorHover = "#0058B3";
var ActionColorAdd = "#5FA253";
var ActionColorDelete = "#AE304A";
var SpaceXXL = "48px";
var SpaceXL = "32px";
var SpaceLX = "24px";
var SpaceL = "20px";
var SpaceM = "16px";
var SpaceSM = "12px";
var SpaceS = "8px";
var SpaceXS = "4px";
var ControlBorderRadiusDefault = "3px";
var ControlHeightDefault = "24px";
var ControlHeightLarge = "28px";
var ControlHeightXLarge = "40px";
var ControlDisabledOpacity = "0.5";
var PlaceholderColorDefault = "rgba(0, 0, 0, 0.7)";
var ControlBackgroundColorDark = "#F5F6F6";
var ControlBorderColorDefault = "rgba(64, 66, 73, 0.2)";
var ControlBorderColorHover = "rgba(64, 66, 73, 0.4)";
var ControlBorderColorDisabled = "rgba(64, 66, 73, 0.2)";
var ControlBorderColorFocusDefault = "#007EFF";
var ControlBorderColorFocusError = "#AE304A";
var ControlColorDisabled = "rgba(236, 236, 237, 0.7)";
var ControlBoxShadowFocusTransparent = "0 0 0 3px transparent";
var ControlBoxShadowFocusDefault = "0 0 0 3px rgba(0, 126, 255, 0.2)";
var ControlBoxShadowFocusError = "0 0 0 3px rgba(174, 48, 74, 0.4)";
var ControlHighlightedBoxShadowFocus = "0 0 0 3px rgba(252, 245, 219, 0.2)";
var ControlHighlightedSuccessBoxShadowFocus = "0 0 0 3px rgba(95, 162, 83, 0.2)";
var ButtonLineHeightDefault = "22px";
var ButtonColorDefault = "#000000";
var ButtonColorChecked = "#000000";
var ButtonBorderColorDefault = "#E2E3E4";
var ButtonBorderColorHover = "#ECECED";
var ButtonBorderColorChecked = "#E2E3E4";
var ButtonBorderColorDisabled = "#E2E3E4";
var ButtonBackgroundDefault = "#F5F6F6";
var ButtonBackgroundHover = "#ECECED";
var ButtonBackgroundChecked = "#E2E3E4";
var ButtonBackgroundActive = "#E2E3E4";
var IconsSizeDefault = "16px";
var IconsGeneralColor = "#66686D";
var ActionIconOpacity = 0.8;
var BackgroundDefault = "#FFFFFF";
var BackgroundInvert = "#000000";
var HighlightBlockBackground = "#F5F6F6";
var HighlightBlockBorderColor = "rgba(64, 66, 73, 0.1)";
var SelectedTagBackground = "#F5F6F6";
var ActionBackgroundHover = "#F9E9AE";
var ActionBackgroundActive = "#F1CE4A";
var ActionBackgroundSelected = "#F1CE4A";
var ActionBackgroundSystem = "#F9E9AE";
var ActionBackgroundSuccess = "#E7F1E5";
var ActionBackgroundWarning = "#FAEAD2";
var ActionBackgroundDelete = "#F3E0E4";
var DnDPlaceholderBackground = "#007EFF";
var BoxShadowS = "0 1px 2px 0 rgba(0, 0, 0, 0.24)";
var BoxShadowSM = "0 2px 4px 0 rgba(0, 0, 0, 0.16)";
var BoxShadowM = "0 1px 10px 0 rgba(0, 0, 0, 0.12)";
var BoxShadowL = "0 4px 16px 0 rgba(0, 0, 0, 0.12)";
var ZIndexBoard = 1;
var ZIndexPanel = 102;
var ZIndexOverlay = 10000;
var ZIndexModal = 10001;
var ZIndexModalPlus = 10002;

export { FontFamily, FontSizeTitleHeadline, FontSizeTitleSection, FontSizeTitleSubsection, FontSizeDefault, FontSizeLabel, FontWeightSemibold, FontWeightNormal, FontWeightLight, BorderRadiusDefault, BorderRadiusL, FontColorDefault, FontColorGray, FontColorLightGray, FontColorWhite, FontColorError, FontColorAttention, FontColorWarning, FontColorSuccess, FontColorSelected, LinkColor, LinkColorHover, ActionColorAdd, ActionColorDelete, SpaceXXL, SpaceXL, SpaceLX, SpaceL, SpaceM, SpaceSM, SpaceS, SpaceXS, ControlBorderRadiusDefault, ControlHeightDefault, ControlHeightLarge, ControlHeightXLarge, ControlDisabledOpacity, PlaceholderColorDefault, ControlBackgroundColorDark, ControlBorderColorDefault, ControlBorderColorHover, ControlBorderColorDisabled, ControlBorderColorFocusDefault, ControlBorderColorFocusError, ControlColorDisabled, ControlBoxShadowFocusTransparent, ControlBoxShadowFocusDefault, ControlBoxShadowFocusError, ControlHighlightedBoxShadowFocus, ControlHighlightedSuccessBoxShadowFocus, ButtonLineHeightDefault, ButtonColorDefault, ButtonColorChecked, ButtonBorderColorDefault, ButtonBorderColorHover, ButtonBorderColorChecked, ButtonBorderColorDisabled, ButtonBackgroundDefault, ButtonBackgroundHover, ButtonBackgroundChecked, ButtonBackgroundActive, IconsSizeDefault, IconsGeneralColor, ActionIconOpacity, BackgroundDefault, BackgroundInvert, HighlightBlockBackground, HighlightBlockBorderColor, SelectedTagBackground, ActionBackgroundHover, ActionBackgroundActive, ActionBackgroundSelected, ActionBackgroundSystem, ActionBackgroundSuccess, ActionBackgroundWarning, ActionBackgroundDelete, DnDPlaceholderBackground, BoxShadowS, BoxShadowSM, BoxShadowM, BoxShadowL, ZIndexBoard, ZIndexPanel, ZIndexOverlay, ZIndexModal, ZIndexModalPlus };
